define(['./InsuranceSuiteMetadata'], (XCenters)=> {
    return ['TranslateService', (TranslateService)=> {
        function translate(key) {
            const obj = {};
            TranslateService.translate({
                object: obj,
                propName: 'value',
                displayKey: key
            });
            return ()=> {
                return obj.value;
            };
        }

        return XCenters.createSuiteMetadata(translate);
    }];
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/metamirror/InsuranceSuiteMetadataService.js